module.exports = __webpack_public_path__ + "static/media/betaling-green.2904b6ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/betaling-green.svg
// module id = 1931
// module chunks = 0